module.exports = __webpack_public_path__ + "img/flowers2.ef20ec79.jpg";